// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quotation-detail-container {
    padding: 0 40px 40px;
    background-color: #fff;
    font-size: 14px;
    position: relative;
}

.breadcrumb {
    background-color: #f5f5f5;
    padding: 21px 82px;
    margin: 0 -40px 30px;
    color: #717171;
}

.page-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 30px;
}
.page-title-bar {
    width: 5px;
    height: 24px;
    background-color: #e84118;
}
.page-header h2 {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
}
.quotation-info-box {
    display: flex;
    justify-content: space-between;
    border-top: 2px solid #222;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
}
.info-grid {
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 10px 40px;
}
.info-row {
    display: contents;
}
.info-label {
    font-weight: bold;
    padding: 5px 20px;
}
.info-value {
    padding: 5px 20px;
}
.btn-pdf {
    align-self: flex-start;
    padding: 10px 20px;
    border: 1px solid #222;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
}
.product-list-section {
    margin-top: 20px;
}
.product-list-header {
    display: flex;
    align-items: center;
    background-color: #f9f9f9;
    padding: 15px;
    border-bottom: 1px solid #ddd;
}
.quote-number-header {
    flex-grow: 1;
}
.header-labels {
    display: grid;
    grid-template-columns: 200px 100px 150px 250px;
    text-align: center;
}
.product-list {
    border-bottom: 1px solid #ddd;
    max-height: 400px;
    overflow-y: scroll;
    position: relative;
}

/* Custom Scrollbar */
.product-list::-webkit-scrollbar {
  width: 48px;
}

.product-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}
 
.product-list::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 6px;
}

.product-list::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.product-item-row {
    display: flex;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #eee;
}
.product-item-row:last-child {
    border-bottom: none;
}
.col-1 { padding-right: 15px; }
.col-2 { padding-right: 15px; }
.col-3 { flex-grow: 1; }
.col-4, .col-5, .col-6 { 
    text-align: center; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.col-4 { width: 100px; margin-left: auto;}
.col-5 { width: 150px; }
.col-6 { width: 250px; }
.product-image { width: 100px; height: auto; border: 1px solid #eee; }

.admin-quotation-image {
    width: 60px !important;
    height: 60px !important;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    flex-shrink: 0;
}
.product-details { font-size: 13px; }
.product-name { font-weight: bold; margin: 0 0 5px; }
.product-option, .product-spec { color: #666; margin: 0; }
.quantity-input, .date-input {
    width: 100%;
    max-width: 120px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    text-align: center;
    box-sizing: border-box;
}
.product-status { 
    display: flex; 
    flex-direction: column; 
    gap: 8px; 
    width: 100%;
    align-items: center;
}
.product-status select {
    width: 100%;
    max-width: 200px;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 13px;
    box-sizing: border-box;
}
.inquiry-section, .memo-section, .additional-request-section {
    margin-top: 20px;
    display: flex;
}

/* 추가요청사항 섹션 특별 스타일 */
.additional-request-section {
    background-color: #fff8e1;
    border-left: 4px solid #ff9800;
    border-radius: 5px;
}
.inquiry-label, .memo-label {
    width: 150px;
    font-weight: bold;
    padding: 15px 20px;
    background-color: #f9f9f9;
    border-bottom: 1px solid #ddd;
}
.inquiry-content, .memo-content {
    flex-grow: 1;
    padding: 15px 20px;
    border-bottom: 1px solid #ddd;
}
.inquiry-content p {
    margin: 0;
    white-space: pre-wrap;
}
.memo-content textarea {
    width: 100%;
    height: 120px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    resize: vertical;
}
.checkbox-container input {
    margin-right: 5px;
}

.page-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 50px;
    border-top: 1px solid #222;
    padding-top: 40px;
}

.page-actions button {
    width: 350px;
    padding: 15px;
    border-radius: 5px;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-secondary {
    background-color: #222;
    color: white;
    border: none;
}

.btn-primary {
    background-color: #e84118;
    color: white;
    border: none;
}

.arrow-icon {
    font-size: 16px;
    font-weight: bold;
}

/* 고객 상세 정보 섹션 */
.customer-detail-section {
    margin: 30px 0;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
}

.customer-detail-header {
    background-color: #f8f9fa;
    padding: 15px 20px;
    border-bottom: 1px solid #ddd;
}

.customer-detail-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.customer-detail-grid {
    padding: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
}

.customer-detail-row {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
}

.customer-detail-row:last-child {
    border-bottom: none;
}

.customer-address-row,
.customer-delivery-row {
    grid-column: 1 / -1;
}

.customer-detail-label {
    min-width: 120px;
    font-weight: 600;
    color: #555;
    flex-shrink: 0;
}

.customer-detail-value {
    flex: 1 1;
    color: #333;
}

.address-line {
    margin: 2px 0;
}

.zip-code {
    font-weight: 600;
    color: #007bff;
}

/* 배송지 목록 스타일 */
.delivery-addresses-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.delivery-address-item {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 15px;
    background-color: #fafafa;
}

.delivery-address-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
}

.delivery-address-name {
    font-weight: 600;
    color: #333;
    position: relative;
}

.default-badge {
    background-color: #28a745;
    color: white;
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 10px;
    margin-left: 8px;
    font-weight: 500;
}

.delivery-address-recipient {
    color: #666;
    font-size: 14px;
}

.delivery-address-details {
    margin-top: 8px;
}

.delivery-address-details .address-line {
    margin: 3px 0;
    font-size: 14px;
}

.contact-info {
    color: #666;
    font-size: 13px;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .info-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }
    .customer-detail-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }
    .product-list-header, .product-item-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding: 10px;
    }
    .header-labels {
        grid-template-columns: repeat(4, 1fr);
        width: 100%;
    }
    .col-4, .col-5, .col-6 {
        width: 100%;
        margin-left: 0;
    }
    .page-actions button {
        width: 250px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .quotation-detail-container {
        padding: 0 20px 20px;
    }
    .quotation-info-box {
        flex-direction: column;
        gap: 15px;
    }
    .header-labels {
        display: none;
    }
    
    .product-item-row {
        position: relative;
        padding-top: 40px;
    }
    .product-item-row::before {
        content: '수량 / 희망납기 / 진행사항';
        position: absolute;
        top: 10px;
        left: 10px;
        font-weight: bold;
        font-size: 14px;
        color: #333;
    }

    .col-4, .col-5, .col-6 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #eee;
        padding-top: 10px;
    }
    
    .col-4::before { content: '수량'; font-weight: bold; }
    .col-5::before { content: '희망납기'; font-weight: bold; }
    .col-6::before { content: '진행사항'; font-weight: bold; }
    
    .inquiry-section, .memo-section {
        flex-direction: column;
    }
    .inquiry-label, .memo-label {
        width: 100%;
    }
    
    .page-actions {
        flex-direction: column;
    }
    .page-actions button {
        width: 100%;
    }
}

/* 고객 첨부파일 섹션 스타일 */
.customer-files-section {
    border-top: 1px solid #ddd;
    padding: 20px 0;
    margin: 20px 0;
}

.customer-files-list {
    background-color: #f9f9f9;
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 15px;
}

.customer-file-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px solid #eee;
}

.customer-file-item:last-child {
    border-bottom: none;
}

.file-icon {
    font-size: 16px;
    color: #666;
}

.file-name {
    flex: 1 1;
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

.file-size {
    font-size: 12px;
    color: #888;
}

.file-actions {
    display: flex;
    gap: 8px;
}

.btn-download, .btn-preview {
    padding: 4px 8px;
    font-size: 12px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.btn-download {
    background-color: #007bff;
    color: white;
}

.btn-download:hover {
    background-color: #0056b3;
}

.btn-preview {
    background-color: #28a745;
    color: white;
}

.btn-preview:hover {
    background-color: #1e7e34;
} `, "",{"version":3,"sources":["webpack://./src/admin/css/QuotationDetailPage.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,aAAa;IACb,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,8CAA8C;IAC9C,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;AACA,SAAS,mBAAmB,EAAE;AAC9B,SAAS,mBAAmB,EAAE;AAC9B,SAAS,YAAY,EAAE;AACvB;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,SAAS,YAAY,EAAE,iBAAiB,CAAC;AACzC,SAAS,YAAY,EAAE;AACvB,SAAS,YAAY,EAAE;AACvB,iBAAiB,YAAY,EAAE,YAAY,EAAE,sBAAsB,EAAE;;AAErE;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;AACA,mBAAmB,eAAe,EAAE;AACpC,gBAAgB,iBAAiB,EAAE,eAAe,EAAE;AACpD,iCAAiC,WAAW,EAAE,SAAS,EAAE;AACzD;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;IACA;QACI,0BAA0B;QAC1B,SAAS;IACb;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,aAAa;IACjB;IACA;QACI,qCAAqC;QACrC,WAAW;IACf;IACA;QACI,WAAW;QACX,cAAc;IAClB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,oBAAoB;IACxB;IACA;QACI,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,2BAA2B;QAC3B,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,iBAAiB;QACjB,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA,iBAAiB,aAAa,EAAE,iBAAiB,EAAE;IACnD,iBAAiB,eAAe,EAAE,iBAAiB,EAAE;IACrD,iBAAiB,eAAe,EAAE,iBAAiB,EAAE;;IAErD;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAO;IACP,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".quotation-detail-container {\n    padding: 0 40px 40px;\n    background-color: #fff;\n    font-size: 14px;\n    position: relative;\n}\n\n.breadcrumb {\n    background-color: #f5f5f5;\n    padding: 21px 82px;\n    margin: 0 -40px 30px;\n    color: #717171;\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 30px;\n}\n.page-title-bar {\n    width: 5px;\n    height: 24px;\n    background-color: #e84118;\n}\n.page-header h2 {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n}\n.quotation-info-box {\n    display: flex;\n    justify-content: space-between;\n    border-top: 2px solid #222;\n    border-bottom: 1px solid #eee;\n    padding: 10px 0;\n}\n.info-grid {\n    display: grid;\n    grid-template-columns: repeat(2, auto);\n    gap: 10px 40px;\n}\n.info-row {\n    display: contents;\n}\n.info-label {\n    font-weight: bold;\n    padding: 5px 20px;\n}\n.info-value {\n    padding: 5px 20px;\n}\n.btn-pdf {\n    align-self: flex-start;\n    padding: 10px 20px;\n    border: 1px solid #222;\n    background-color: white;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: bold;\n}\n.product-list-section {\n    margin-top: 20px;\n}\n.product-list-header {\n    display: flex;\n    align-items: center;\n    background-color: #f9f9f9;\n    padding: 15px;\n    border-bottom: 1px solid #ddd;\n}\n.quote-number-header {\n    flex-grow: 1;\n}\n.header-labels {\n    display: grid;\n    grid-template-columns: 200px 100px 150px 250px;\n    text-align: center;\n}\n.product-list {\n    border-bottom: 1px solid #ddd;\n    max-height: 400px;\n    overflow-y: scroll;\n    position: relative;\n}\n\n/* Custom Scrollbar */\n.product-list::-webkit-scrollbar {\n  width: 48px;\n}\n\n.product-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n \n.product-list::-webkit-scrollbar-thumb {\n  background: #888; \n  border-radius: 6px;\n}\n\n.product-list::-webkit-scrollbar-thumb:hover {\n  background: #555; \n}\n\n.product-item-row {\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    border-bottom: 1px solid #eee;\n}\n.product-item-row:last-child {\n    border-bottom: none;\n}\n.col-1 { padding-right: 15px; }\n.col-2 { padding-right: 15px; }\n.col-3 { flex-grow: 1; }\n.col-4, .col-5, .col-6 { \n    text-align: center; \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.col-4 { width: 100px; margin-left: auto;}\n.col-5 { width: 150px; }\n.col-6 { width: 250px; }\n.product-image { width: 100px; height: auto; border: 1px solid #eee; }\n\n.admin-quotation-image {\n    width: 60px !important;\n    height: 60px !important;\n    object-fit: cover;\n    border-radius: 4px;\n    border: 1px solid #dee2e6;\n    flex-shrink: 0;\n}\n.product-details { font-size: 13px; }\n.product-name { font-weight: bold; margin: 0 0 5px; }\n.product-option, .product-spec { color: #666; margin: 0; }\n.quantity-input, .date-input {\n    width: 100%;\n    max-width: 120px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    text-align: center;\n    box-sizing: border-box;\n}\n.product-status { \n    display: flex; \n    flex-direction: column; \n    gap: 8px; \n    width: 100%;\n    align-items: center;\n}\n.product-status select {\n    width: 100%;\n    max-width: 200px;\n    padding: 8px 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 13px;\n    box-sizing: border-box;\n}\n.inquiry-section, .memo-section, .additional-request-section {\n    margin-top: 20px;\n    display: flex;\n}\n\n/* 추가요청사항 섹션 특별 스타일 */\n.additional-request-section {\n    background-color: #fff8e1;\n    border-left: 4px solid #ff9800;\n    border-radius: 5px;\n}\n.inquiry-label, .memo-label {\n    width: 150px;\n    font-weight: bold;\n    padding: 15px 20px;\n    background-color: #f9f9f9;\n    border-bottom: 1px solid #ddd;\n}\n.inquiry-content, .memo-content {\n    flex-grow: 1;\n    padding: 15px 20px;\n    border-bottom: 1px solid #ddd;\n}\n.inquiry-content p {\n    margin: 0;\n    white-space: pre-wrap;\n}\n.memo-content textarea {\n    width: 100%;\n    height: 120px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 10px;\n    resize: vertical;\n}\n.checkbox-container input {\n    margin-right: 5px;\n}\n\n.page-actions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 50px;\n    border-top: 1px solid #222;\n    padding-top: 40px;\n}\n\n.page-actions button {\n    width: 350px;\n    padding: 15px;\n    border-radius: 5px;\n    font-size: 18px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.btn-secondary {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.btn-primary {\n    background-color: #e84118;\n    color: white;\n    border: none;\n}\n\n.arrow-icon {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n/* 고객 상세 정보 섹션 */\n.customer-detail-section {\n    margin: 30px 0;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.customer-detail-header {\n    background-color: #f8f9fa;\n    padding: 15px 20px;\n    border-bottom: 1px solid #ddd;\n}\n\n.customer-detail-header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.customer-detail-grid {\n    padding: 20px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 15px;\n}\n\n.customer-detail-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 15px;\n    padding: 8px 0;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.customer-detail-row:last-child {\n    border-bottom: none;\n}\n\n.customer-address-row,\n.customer-delivery-row {\n    grid-column: 1 / -1;\n}\n\n.customer-detail-label {\n    min-width: 120px;\n    font-weight: 600;\n    color: #555;\n    flex-shrink: 0;\n}\n\n.customer-detail-value {\n    flex: 1;\n    color: #333;\n}\n\n.address-line {\n    margin: 2px 0;\n}\n\n.zip-code {\n    font-weight: 600;\n    color: #007bff;\n}\n\n/* 배송지 목록 스타일 */\n.delivery-addresses-list {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.delivery-address-item {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 15px;\n    background-color: #fafafa;\n}\n\n.delivery-address-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 8px;\n}\n\n.delivery-address-name {\n    font-weight: 600;\n    color: #333;\n    position: relative;\n}\n\n.default-badge {\n    background-color: #28a745;\n    color: white;\n    font-size: 11px;\n    padding: 2px 6px;\n    border-radius: 10px;\n    margin-left: 8px;\n    font-weight: 500;\n}\n\n.delivery-address-recipient {\n    color: #666;\n    font-size: 14px;\n}\n\n.delivery-address-details {\n    margin-top: 8px;\n}\n\n.delivery-address-details .address-line {\n    margin: 3px 0;\n    font-size: 14px;\n}\n\n.contact-info {\n    color: #666;\n    font-size: 13px;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .info-grid {\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n    .customer-detail-grid {\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n    .product-list-header, .product-item-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        padding: 10px;\n    }\n    .header-labels {\n        grid-template-columns: repeat(4, 1fr);\n        width: 100%;\n    }\n    .col-4, .col-5, .col-6 {\n        width: 100%;\n        margin-left: 0;\n    }\n    .page-actions button {\n        width: 250px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .quotation-detail-container {\n        padding: 0 20px 20px;\n    }\n    .quotation-info-box {\n        flex-direction: column;\n        gap: 15px;\n    }\n    .header-labels {\n        display: none;\n    }\n    \n    .product-item-row {\n        position: relative;\n        padding-top: 40px;\n    }\n    .product-item-row::before {\n        content: '수량 / 희망납기 / 진행사항';\n        position: absolute;\n        top: 10px;\n        left: 10px;\n        font-weight: bold;\n        font-size: 14px;\n        color: #333;\n    }\n\n    .col-4, .col-5, .col-6 {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-top: 1px solid #eee;\n        padding-top: 10px;\n    }\n    \n    .col-4::before { content: '수량'; font-weight: bold; }\n    .col-5::before { content: '희망납기'; font-weight: bold; }\n    .col-6::before { content: '진행사항'; font-weight: bold; }\n    \n    .inquiry-section, .memo-section {\n        flex-direction: column;\n    }\n    .inquiry-label, .memo-label {\n        width: 100%;\n    }\n    \n    .page-actions {\n        flex-direction: column;\n    }\n    .page-actions button {\n        width: 100%;\n    }\n}\n\n/* 고객 첨부파일 섹션 스타일 */\n.customer-files-section {\n    border-top: 1px solid #ddd;\n    padding: 20px 0;\n    margin: 20px 0;\n}\n\n.customer-files-list {\n    background-color: #f9f9f9;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    padding: 15px;\n}\n\n.customer-file-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 0;\n    border-bottom: 1px solid #eee;\n}\n\n.customer-file-item:last-child {\n    border-bottom: none;\n}\n\n.file-icon {\n    font-size: 16px;\n    color: #666;\n}\n\n.file-name {\n    flex: 1;\n    font-size: 14px;\n    color: #333;\n    font-weight: 500;\n}\n\n.file-size {\n    font-size: 12px;\n    color: #888;\n}\n\n.file-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.btn-download, .btn-preview {\n    padding: 4px 8px;\n    font-size: 12px;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.btn-download {\n    background-color: #007bff;\n    color: white;\n}\n\n.btn-download:hover {\n    background-color: #0056b3;\n}\n\n.btn-preview {\n    background-color: #28a745;\n    color: white;\n}\n\n.btn-preview:hover {\n    background-color: #1e7e34;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
